import React from 'react';
import { Navigate } from 'react-router-dom';

// Template
import DashboardLayout from '@template/Dashboard';
import MainLayout from '@template/Main';

// Auth
import LoginView from '@pages/auth/LoginView';
import RegisterView from '@pages/auth/RegisterView';

// Views
import NotFoundView from '@pages/errors/NotFoundView';
import BriefingView from '@pages/briefing';
import MemberShipView from '@pages/membership';
import StockRecommendView from '@pages/stockRecommend/stockRecommendView';
import ProfitView from '@pages/profits';
import VipContactListView from '@pages/contacts';

import Storage from '@utils/Storage';

const Routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'briefing', element: <BriefingView /> },
      { path: 'profits', element: <ProfitView /> },
      { path: 'vip-contacts', element: <VipContactListView /> },
      { path: 'membership', element: <MemberShipView /> },
      { path: 'stock-recommend', element: <StockRecommendView /> },

      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <LoginView /> },
      { path: 'register', element: <RegisterView /> },
      { path: '404', element: <NotFoundView /> },
      {
        path: '/',
        element: Storage.get('userInfo') ? (
          <Navigate to="/app" />
        ) : (
          <Navigate to="/login" />
        )
      },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default Routes;
